/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddMemberRequest } from '../../models/add-member-request';
import { OrganizationUserDto } from '../../models/organization-user-dto';

export interface OrganizationMembersPost$Plain$Params {
      body?: AddMemberRequest
}

export function organizationMembersPost$Plain(http: HttpClient, rootUrl: string, params?: OrganizationMembersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
  const rb = new RequestBuilder(rootUrl, organizationMembersPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationUserDto>;
    })
  );
}

organizationMembersPost$Plain.PATH = '/organization/members';
